import React from "react";
import TagManager from "react-gtm-module";
import styled from "styled-components";

export default function ShareButtons({ twitter, linkedIn, name }) {
  return (
    <ShareRow>
      <a
        onClick={() => {
          const tagManagerArgs = {
            dataLayer: {
              event: "gaQuizEvent",
              eventAction: `${name}`,
              eventLabel: `Quiz Complete - Twitter Share`,
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }}
        target="_blank"
        rel="noreferrer"
        href={twitter}
        aria-label="Share site on Twitter."
      >
        <img alt="twitter" src={"share-twitter.svg"} />
      </a>
      <a
        onClick={() => {
          const tagManagerArgs = {
            dataLayer: {
              event: "gaQuizEvent",
              eventAction: `${name}`,
              eventLabel: `Quiz Complete - Linkedin Share`,
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }}
        target="_blank"
        rel="noreferrer"
        href={linkedIn}
        aria-label="Share site on LinkedIn"
      >
        <img alt="linkedIn" src={"share-linkedin.svg"} />
      </a>
    </ShareRow>
  );
}

const ShareRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  a:not(:last-child) {
    margin-right: 15px;
  }
  a {
    border-radius: 50%;
  }

  img {
    width: 25px;
    border-radius: 50%;
    &:hover {
      box-shadow: 0 1px 3px 1px rgba(60, 64, 67, 0.15),
        0 1px 2px 0 rgba(60, 64, 67, 0.3);
    }
  }
`;
